import React, { FC, useState } from "react";
import { icons, LABELS, PAGINATION_DROP } from "../../constants";
import { usePagination } from "../../utils/hooks/usePagination";

interface PaginationProps {
  count: number;
  setSort: (sort: Sort) => void;
  sort: Sort;
}

interface Sort {
  skip: number;
  limit: number;
}

const Pagination: FC<PaginationProps> = (props) => {
  const { count, setSort, sort } = props;

  const DOTS = "...";

  const endData: number =
    sort.skip + sort.limit > count ? count : sort.skip + sort.limit;
  const startData: number = sort.skip + 1;
  const val: number = sort.skip + sort.limit;
  const page: number = Math.round(val / sort.limit);

  // const lastIndex: number = Math.ceil(count / sort.limit);

  const [currentPage, setCurrentPage] = useState<number>(page);

  const pageSize: number = sort.limit;
  const siblingCount: number = 1;
  const totalCount: number = count;

  const paginationRange = usePagination({
    totalCount,
    pageSize,
    siblingCount,
    currentPage,
  });

  const handlePage = (e: number): void => {
    let s: number = (e - 1) * sort.limit;
    setSort({ ...sort, skip: s });
    setCurrentPage(e);
  };

  const goNext = (): void => {
    if (sort.skip + sort.limit < count) {
      let s: number = page * sort.limit;
      setSort({ ...sort, skip: s });
      setCurrentPage(page + 1);
    }
  };

  const goPrev = (): void => {
    if (sort.skip > 0) {
      let s: number = (page - 2) * sort.limit;
      setSort({ ...sort, skip: s });
      setCurrentPage(page - 1);
    }
  };

  const handleLimit = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    setSort({ ...sort, limit: parseInt(e.target.value), skip: 0 });
  };

  return (
    <>
      <div className="col-12 col-md-6">
        <div className="d-flex align-items-center">
          <div className="form-group mb-0">
            {LABELS.SHOW_TEXT}
            <select
              className="form-control w-auto d-inline-block"
              value={sort.limit}
              onChange={handleLimit}
            >
              {PAGINATION_DROP.map((val: any) => {
                return (
                  <option value={val._id} key={val._id}>
                    {val.name}
                  </option>
                );
              })}
            </select>
            &nbsp; Entries
          </div>
          <div className="form-group mb-0 text-center page-showing">
            {LABELS.SHOWING_TEXT} {startData} to {endData} of {count}{" "}
            {LABELS.ENTRIES_TEXT}
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6">
        <nav>
          <ul className="pagination mb-0 justify-content-end">
            <li
              className={`page-item ${sort.skip === 0 && "custom-disabled"}`}
              onClick={goPrev}
            >
              <a className="page-link" href="javascript:void(0)">
                <i className={`icon ${icons.ICON_CHEVRON_LEFT} `}></i>
              </a>
            </li>

            {paginationRange?.map((pageNumber: any, index) => {
              if (pageNumber === DOTS) {
                return (
                  <li className="dots" key={index}>
                    <a className="page-link" href="javascript:void(0);">
                      ...
                    </a>
                  </li>
                );
              }

              return (
                <li
                  key={`page-${pageNumber}-${index}`}
                  className={`page-item ${pageNumber === page && " active"} `}
                  onClick={() => handlePage(pageNumber)}
                >
                  <a className="page-link" href="javascript:void(0);">
                    {pageNumber}
                  </a>
                </li>
              );
            })}

            <li
              className={`page-item ${
                sort.skip + sort.limit >= count && "custom-disabled"
              }`}
              onClick={goNext}
            >
              <a className="page-link" href="javascript:void(0);">
                <i className={`icon ${icons.ICON_CHEVRON_RIGHT}`}></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Pagination;
